import { RootStateOrAny } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'

import { menuFetcherV3, MenuRequestParamsV3 } from '@library/menu-service'

import { menuServiceV3DataReceived } from 'actions/menu/menuV3'

export const fetchMenuV3 =
  (params: MenuRequestParamsV3) =>
  async (dispatch: ThunkDispatch<RootStateOrAny, unknown, AnyAction>): Promise<void> => {
    const menuResponseV3 = await menuFetcherV3({
      deliveryDate: params.deliveryDate,
      numPortions: params.numPortions,
      sessionId: params.sessionId,
    })

    dispatch(menuServiceV3DataReceived(menuResponseV3))
  }
